module.exports = __webpack_public_path__ + "img/slide7-en.3bff18f9.png";